module.exports = __webpack_public_path__ + "static/img/download_content2.c7c2a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_content2.png
// module id = peFw
// module chunks = 1